import { MutationTree } from "vuex";
import { StatisticState } from "./types";

export const mutations: MutationTree<StatisticState> = {

  setStaticGroupIncoming: (state, data) => {
    state.statisticGroupIncoming = data;
  },
  setStatisticDetailIncoming: (state, data) => {
    state.statisticDetailIncoming = data;
  },
  pushStatisticDetailIncoming: (state, data) => {
    state.statisticDetailIncoming = state.statisticDetailIncoming?.concat(data);
  },
  setStatisticDetailIncomingFlag: (state, flag: string) => {
    state.statisticDetailIncomingFlag = flag;
  },
  resetStatisticDetailIncomingState(state) {
    state.statisticGroupIncoming = [];
  },
};
